<div class="service-card-content">
  <div class="role-card-content">
    <h6
      class="service-role-name"
      [class.no-responsibility]="
        flow !== EditSuborganizationsRoleAssignmentFlow.Preview
      "
    >
      {{ role.localizedDisplayName }}
    </h6>

    @if (flow === EditSuborganizationsRoleAssignmentFlow.Preview) {
      <div class="responsibility-content">
        <p class="responsibility">
          {{
            'cartridge.roles.editSuborganizations.responsibleFor' | transloco
          }}
        </p>
      </div>
    }

    <div class="suborganizations-container">
      @if (suborganizations$ | async; as loadedSuborganizations) {
        @if (
          flow === EditSuborganizationsRoleAssignmentFlow.Add ||
          loadedSuborganizations.length === 0
        ) {
          <markant-platform-ui-cartridge-roles-assignment-item
            data-cy="add-overall-responsibility-card"
            [suborganizationName]="
              'cartridge.roles.assignment.allLocations' | transloco
            "
            [flow]="flow"
            [isSelected]="!shouldEnableOverallResponsibility"
            [isClickable]="shouldEnableOverallResponsibility"
            [isOverallResponsibility]="true"
            (added)="onOverallResponsibilityAdded()"
          ></markant-platform-ui-cartridge-roles-assignment-item>
        }
      }

      @for (suborganization of suborganizations$ | async; track $index) {
        <markant-platform-ui-cartridge-roles-assignment-item
          data-cy="add-role-card"
          [suborganizationName]="suborganization.name"
          [flow]="flow"
          [isSelected]="
            suborganization.selected &&
            flow === EditSuborganizationsRoleAssignmentFlow.Add
          "
          [isClickable]="
            !suborganization.selected &&
            flow === EditSuborganizationsRoleAssignmentFlow.Add
          "
          (added)="onAddClick(suborganization)"
          (removed)="onRemoveClick(suborganization)"
        ></markant-platform-ui-cartridge-roles-assignment-item>
      }
    </div>
  </div>
</div>
